<template>
  <span class="product-code" :class="{'product-code--adaptive': isAdaptive}">
    <meta itemprop="sku" :content="code">
    {{ $t('product_code') + ' ' + code }}
  </span>
</template>

<script>
export default {
  name: 'ProductCode',
  props: {
    code: {
      type: String,
      default: ''
    },
    isAdaptive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="sass">

.product-code
  font-size: 14px
  color: $placeholder-color
  word-break: keep-all
  margin-bottom: 5px

.product-code--adaptive
  font-size: 12px

.product-card .product-code
  +mmin($tablet)
    margin-top: 5px
</style>
